import {useState, useEffect} from 'react'
import {Box, Grid, Typography} from '@mui/material'
import Header from '../../../components/Header'
import EntropyCard from './tiresia-networkComponents/EntropyCard'
import API from "../../../api";
import NetworkTrafficChart from "./tiresia-networkComponents/NetworkTrafficChart"
const TiresiaNetworkPage = () => {
    const [entropy, setEntropy] = useState({})
    const threesholdsEntropy = {
        ip_port:[1, 2.5],
        protocol_iface: [0.5, 1.5],
    }
    const infoText = {
      ipSource: "\bCentralised\b: Traffic from a few devices;\n   \bDistributed\b: Traffic from many hosts",
      ipDestination: "\bCentralised\b: Traffic to a few or a single server;\n   \bDistributed\b: Various destinations, scattered",
      ports: "\bCentralised\b: Only a few or one target port, known communication;\n   \bDistributed\b: Many different ports",
      protocol: "\bCentralised\b: Almost all traffic is on a single protocol (e.g. TCP-only);\n   \bDistributed\b: Many protocols used",
      iface: "Centralised: All traffic on a single interface;\n   Distributed: Wide distribution across interfaces, multi-input"
    }
    useEffect(() => {
        API.getTiresiaEntropy().then(res => {
            setEntropy(res.data)
        })
    }, [])
    return (
            <Box m="20px">
              {/* HEADER */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="TIRES-IA NETWORK" subtitle="" />
              </Box>
        
              {/* GRID & CHARTS */}
              <Grid container spacing={2} sx={{ paddingBottom: 20 }}>
        
                {/* ROW 1 */}
                <Grid size={12} style={{marginBottom: 6, marginTop: 6}}><Typography style={{fontSize: 17, fontWeight: 600}}>ENTROPY ANALYSIS</Typography></Grid>
                <Grid size={4}><EntropyCard value={entropy.ipSource && entropy.ipSource} threesholds={threesholdsEntropy.ip_port} title={"IP SOURCE"} infoText={infoText.ipSource} /></Grid>
                <Grid size={4}><EntropyCard value={entropy.ipDestination && entropy.ipDestination} threesholds={threesholdsEntropy.ip_port} title={"IP DESTINATION"} infoText={infoText.ipDestination} /></Grid>
                <Grid size={4}><EntropyCard value={entropy.ports && entropy.ports} threesholds={threesholdsEntropy.ip_port} title={"PORTS DESTINATION"} infoText={infoText.ports} /></Grid>
                <Grid size={2}></Grid>
                <Grid size={4}><EntropyCard value={entropy.protocol && entropy.protocol} threesholds={threesholdsEntropy.protocol_iface} title={"PROTOCOLS"} infoText={infoText.protocol} /></Grid>
                <Grid size={4}><EntropyCard value={entropy.in_iface && entropy.in_iface} threesholds={threesholdsEntropy.protocol_iface} title={"INTERNET INTERFACE"} infoText={infoText.iface} /></Grid>
                <Grid size={2}></Grid>
                <Grid size={12} style={{marginBottom: 6, marginTop: 6}}><Typography style={{fontSize: 17, fontWeight: 600}}>BPS/PPS ANALYSIS</Typography></Grid>
                {/* ROW 3 */}
                <Grid size={12}>
                <NetworkTrafficChart />
                </Grid>
              </Grid>
            </Box>
    )
}

export default TiresiaNetworkPage